import { IconButton } from "@fidelix/fx-miranda";
import JSZip from "jszip";
import { Dispatch, SetStateAction } from "react";
import { fetchGraphicsAttachments } from "./graphics.queries";
import { useRequiredParams } from "../utils/url";

type Props = {
  graphicsId: number;
  name: string;
  isDownloading: boolean;
  setIsDownloading: Dispatch<SetStateAction<boolean>>;
};
export function DownloadGraphics({
  graphicsId,
  name,
  isDownloading,
  setIsDownloading,
}: Props) {
  const { companyId } = useRequiredParams({ companyId: "number" });

  const handleDownloadFile = async () => {
    setIsDownloading(true);

    try {
      const attachments = await fetchGraphicsAttachments({
        graphicsId,
        companyId,
      });

      const zip = new JSZip();
      for (const attachment of attachments) {
        if (!attachment.publicUrl || !attachment.name) {
          continue;
        }
        const response = await fetch(attachment.publicUrl);
        if (!response.ok) {
          throw new Error();
        }
        const fileBlob = await response.blob();
        zip.file(attachment.name, fileBlob);
      }
      const content = await zip.generateAsync({ type: "blob" });
      const graphicsFile = document.createElement("a");
      graphicsFile.href = URL.createObjectURL(content);
      graphicsFile.download = `${name}.zip`;
      graphicsFile.click();
      URL.revokeObjectURL(graphicsFile.href);
    } catch (_err) {
      return undefined;
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <IconButton
      size="small"
      variant="filled"
      icon="download"
      onPress={handleDownloadFile}
      isDisabled={isDownloading}
    />
  );
}
